import { TopTabs } from '@/components/dashboard/TopTabs'
import { UsersSection } from '@/components/admin/UsersSection'
import { SettingsSection } from '@/components/admin/SettingsSection'
import { DataHealthSection } from '@/components/admin/DataHealthSection'
import { SizeNormSection } from '@/components/admin/SizeNormSection'
import { ManualInventorySection } from '@/components/admin/ManualInventorySection'
import { DeletePOSection } from '@/components/admin/DeletePOSection'
import { UnarchivePOSection } from '@/components/admin/UnarchivePOSection'
import { AuditLogSection } from '@/components/admin/AuditLogSection'

export default function Admin() {
  return (
    <div className="brand-theme flex flex-col h-screen bg-[var(--surface-page)] text-[var(--text-primary)]">
      <TopTabs />
      <div className="flex-1 overflow-auto">
        <div className="max-w-6xl mx-auto p-4 space-y-6">
          <h1 className="text-base font-semibold">Admin</h1>
          <UsersSection />
          <hr className="border-[var(--line-warm)]" />
          <SettingsSection />
          <hr className="border-[var(--line-warm)]" />
          <ManualInventorySection />
          <hr className="border-[var(--line-warm)]" />
          <DeletePOSection />
          <hr className="border-[var(--line-warm)]" />
          <UnarchivePOSection />
          <hr className="border-[var(--line-warm)]" />
          <DataHealthSection />
          <hr className="border-[var(--line-warm)]" />
          <SizeNormSection />
          <hr className="border-[var(--line-warm)]" />
          <AuditLogSection />
        </div>
      </div>
    </div>
  )
}
